import {
  AllowStringForNumbers,
  CostInputsPv,
  RecursivePartial,
  Site,
  SiteAllowStringValues,
  SiteElectricalSystem,
} from "@inrange/building-manager-api-client/models-site";
import { SiteCalculationsProvider } from "@inrange/shared-components";
import { Modal, ModalView } from "@inrange/theme-components";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { applySiteUpdate } from "../site/site-utils";
import Generation from "../site/siteSections/Generation";

const BulkEditGeneration = ({
  selectedSiteIds,
  onSitesUpdate,
  onClose,
}: {
  selectedSiteIds: Set<string>;
  onSitesUpdate: (payload: any) => void;
  onClose: () => void;
}) => {
  const [saveNote, setSaveNote] = useState("");
  const [site, setSite] = useState<
    RecursivePartial<
      AllowStringForNumbers<{
        id: string;
        pvInverterBrand: string;
        pvPanelName: string;
        costInputsPv: CostInputsPv;
        generation: {
          [key: string]: unknown;
        };
        esys: {
          [key: string]: {
            idx: number;
            demandIdx: number;
            genIdx: number;
            batteryIdx: number;
          };
        };
      }>
    >
  >({
    id: "bulk-preview",
    costInputsPv: {},
    generation: { "0": {} },
    esys: {
      "0": {
        idx: 0,
        demandIdx: 0,
        genIdx: 0,
        batteryIdx: 0,
      },
    },
  });

  return (
    <Modal>
      <ModalView
        id="bulk-edit-generation"
        title={`Edit Generation for ${selectedSiteIds.size} site${selectedSiteIds.size === 1 ? "" : "s"}`}
        fontWeight="500"
        fontSize="20px"
        width="800px"
        titlePadding="0 0 10px 0"
      >
        <SiteCalculationsProvider
          site={site as unknown as Partial<Site>}
          originalSite={{}}
          app="admin"
          isBulkEdit={true}
        >
          <Generation
            site={site as unknown as SiteAllowStringValues}
            esys={
              site.esys![
                "0"
              ] as unknown as AllowStringForNumbers<SiteElectricalSystem>
            }
            setSite={(update) => {
              setSite((prevSite) =>
                applySiteUpdate(prevSite, update, [
                  "costInputsPv",
                  "generation",
                ])
              );
            }}
            setPendingUpdateSite={() => {}}
            siteFiles={[]}
            onFileAdded={() => {}}
            onFileDeleted={() => {}}
            setSaveDisabled={() => {}}
            pvDesignUploadRef={undefined}
            isBulkEdit={true}
            editMode="SINGLE"
          />
          <Form.Control
            className="mt-3"
            as="textarea"
            rows={2}
            placeholder="Add a short note describing the change made"
            value={saveNote}
            onChange={(e) => setSaveNote(e.target.value)}
            autoFocus
            data-testid="site-save-notes"
          />
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button variant="inrangesecondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={() => {
                const updates = Array.from(selectedSiteIds).reduce(
                  (acc, siteId) => {
                    acc[siteId] = { site };
                    if (saveNote.trim().length > 0) {
                      acc[siteId].userNote = saveNote.trim();
                    }
                    return acc;
                  },
                  {} as { [key: string]: any }
                );
                onSitesUpdate(updates);
              }}
            >
              Edit Generation
            </Button>
          </div>
        </SiteCalculationsProvider>
      </ModalView>
    </Modal>
  );
};

export default BulkEditGeneration;
